enum EFieldName {
  VARIANT = 'variant',
  DOCUMENTS = 'documents',
  LINK = 'link',
  COMMENT = 'comment',
}

export default EFieldName;
